import React, { useState, useMemo } from 'react';

import { FormikHelpers } from 'formik';
import { ThemeProps, withTheme } from 'styled-components';

import BottomSheetOptions from 'components/BottomSheetOptions';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Content, Label, Placeholder, Value } from './styles';

interface Data {
  id: string;
  name: string;
}

interface Props extends ThemeProps<any> {
  title: string;
  placeholder?: string;
  type?: string;
  value?: string;
  name?: string;
  options: Data[];
  disabled?: boolean;
  onClose?: () => void;
  onChange?: (value: any) => void;
  formik?: FormikHelpers<string>;
  zIndex?: number;
  testId?: string;
}

const ModalSelect = ({
  name,
  title,
  placeholder = title,
  disabled,
  value,
  options,
  formik,
  onChange,
  zIndex,
  testId,
}: Props) => {
  const { t } = useStoreTranslation();
  const [showSelect, setShowSelect] = useState(false);

  const item = useMemo(() => options.find((op) => op.id === value), [value, options]);

  const handleShowSelect = () => {
    setShowSelect(true);
  };

  const handleChange = (value: string) => {
    if (formik && name) {
      formik?.setFieldValue(name, value);
    } else if (onChange) {
      onChange(value);
    }
  };

  return (
    <>
      <Container onClick={() => (disabled ? null : handleShowSelect())} data-testid={testId}>
        <Content>
          {item ? (
            <>
              <Label>{title}</Label>
              <Value active={!!item}>{item?.name || t('rulesComponent.rulesSelect')}</Value>
            </>
          ) : (
            <Placeholder>{placeholder}</Placeholder>
          )}
        </Content>
        <img src="/corporate/images/select-arrows.svg" alt="expand" />
      </Container>
      <BottomSheetOptions
        noHeader
        modal
        title={title}
        data={options}
        show={showSelect}
        onChange={handleChange}
        onClose={() => setShowSelect(false)}
        style={{ overflowY: 'scroll', backgroundColor: 'rgb(249, 249, 249)' }}
        zIndex={zIndex}
      />
    </>
  );
};

export default withTheme(ModalSelect);
